import dynamic from 'next/dynamic';
import PublicitatWrapper from './PublicitatWrapper';

// Component that injects SmartAdServer scripts dynamically
const Publicitat = dynamic(() => import('./Publicitat'), { ssr: false });

const PublicitatContainer = (props) => {
    return <PublicitatWrapper {...props} PublicitatComponent={Publicitat} />;
};

export default PublicitatContainer;
